/**
 * FontProbe — renders the exact Devanagari strings this episode needs, in every candidate
 * display font, so conjuncts/matras can be verified IN CHROMIUM (research 01 §I6, 03 §9).
 * ⛔ Do not trust a glyph count. Render it and look at the frame. One frame, once.
 */
import React from "react";
import { AbsoluteFill } from "remotion";
import { loadFont as Modak } from "@remotion/google-fonts/Modak";
import { loadFont as Sarpanch } from "@remotion/google-fonts/Sarpanch";
import { loadFont as Biryani } from "@remotion/google-fonts/Biryani";
import { loadFont as Matangi } from "@remotion/google-fonts/Matangi";
import { loadFont as Yantramanav } from "@remotion/google-fonts/Yantramanav";
import { loadFont as Khand } from "@remotion/google-fonts/Khand";
import { loadFont as AnekDevanagari } from "@remotion/google-fonts/AnekDevanagari";
import { loadFont as Tiro } from "@remotion/google-fonts/TiroDevanagariSanskrit";
import { loadFont as Noto } from "@remotion/google-fonts/NotoSansDevanagari";

const S = { subsets: ["devanagari"] as ("devanagari")[] };
const FONTS: [string, string, number][] = [
  ["Modak", Modak("normal", { weights: ["400"], ...S }).fontFamily, 400],
  ["Sarpanch 900", Sarpanch("normal", { weights: ["900"], ...S }).fontFamily, 900],
  ["Biryani 900", Biryani("normal", { weights: ["900"], ...S }).fontFamily, 900],
  ["Matangi 900", Matangi("normal", { weights: ["900"], ...S }).fontFamily, 900],
  ["Yantramanav 900", Yantramanav("normal", { weights: ["900"], ...S }).fontFamily, 900],
  ["Khand 700", Khand("normal", { weights: ["700"], ...S }).fontFamily, 700],
  ["Anek 800", AnekDevanagari("normal", { weights: ["800"], ...S }).fontFamily, 800],
  ["Tiro 400", Tiro("normal", { weights: ["400"], ...S }).fontFamily, 400],
  ["Noto 900", Noto("normal", { weights: ["900"], ...S }).fontFamily, 900],
];

// every hard shape this episode actually contains
const TEST = "गोत्र · प्रवर · सपिंड · व्यवस्थाएँ · आर्ष · रिषि · संस्कार · ज़्यादातर";

export const FontProbe: React.FC = () => (
  <AbsoluteFill style={{ background: "#F2E9D8", padding: "18px 26px", color: "#12151C" }}>
    {FONTS.map(([label, fam, w]) => (
      <div key={label} style={{ marginBottom: 4 }}>
        <div style={{ fontFamily: "monospace", fontSize: 13, opacity: 0.55 }}>{label}</div>
        <div
          style={{
            fontFamily: fam,
            fontWeight: w,
            fontSize: 40,
            lineHeight: 1.58,
            paddingTop: "0.18em",
            letterSpacing: 0,
            whiteSpace: "nowrap",
          }}
        >
          {TEST}
        </div>
      </div>
    ))}
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
